import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { navigateTo } from '@makemydeal/dr-activities-common';
import { useSelector } from 'react-redux';
import * as routingSelectors from '../selectors/router';

/**
 * Custom React hook to navigate to a specified path using Redux.
 *
 * @param path - The target path to navigate to.
 * @param shouldCheckPath - If true, navigation will be skipped if the current page's path matches the target path. Defaults to false.
 * @returns A callback function that, when invoked, dispatches a navigation action to the specified path unless the current path is the same and skipping is enabled.
 */
export const useNavigate = (path: string, shouldCheckPath: boolean = false) => {
    const dispatch = useDispatch();
    const currentPath = useSelector(routingSelectors.getRouterPathName);

    return useCallback(() => {
        const shouldSkip = shouldCheckPath && currentPath === path;

        if (shouldSkip) return;

        dispatch(navigateTo(path));
    }, [dispatch, path, currentPath, shouldCheckPath]);
};
